import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Animated, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useAppTheme } from '../theme/useAppTheme';

let globalShowToast = null;

export function showToast(message, type = 'success') {
  if (globalShowToast) {
    globalShowToast(message, type);
  }
}

const TOAST_COLORS = {
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
};

export default function Toast() {
  const t = useAppTheme();
  const [state, setState] = useState({ visible: false, message: '', type: 'success' });
  const anim = useRef(new Animated.Value(-100)).current;
  const hideTimer = useRef(null);

  const doShow = useCallback((message, type) => {
    if (hideTimer.current) clearTimeout(hideTimer.current);

    setState({ visible: true, message, type });
    Animated.spring(anim, {
      toValue: 0,
      tension: 120,
      friction: 10,
      useNativeDriver: true,
    }).start();

    hideTimer.current = setTimeout(() => {
      Animated.timing(anim, {
        toValue: -100,
        duration: 250,
        useNativeDriver: true,
      }).start(() => {
        setState((prev) => ({ ...prev, visible: false }));
      });
    }, 2500);
  }, [anim]);

  useEffect(() => {
    globalShowToast = doShow;
    return () => {
      globalShowToast = null;
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, [doShow]);

  if (!state.visible) return null;

  const bgColor = TOAST_COLORS[state.type] || TOAST_COLORS.success;

  return (
    <Animated.View
      style={[
        styles.container,
        {
          backgroundColor: bgColor,
          transform: [{ translateY: anim }],
        },
      ]}
      pointerEvents="none"
    >
      <Text style={styles.text} numberOfLines={2}>
        {state.message}
      </Text>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 60,
    left: 20,
    right: 20,
    zIndex: 9999,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
  },
  text: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
  },
});
